module.exports = __webpack_public_path__ + "img/consult_info4.f14d7d0e.png";